import Schema from '@data-driven-forms/react-form-renderer/dist/cjs/schema';

import { FIELD_NAMES } from '../..';
import {
  DBFormSchema,
  fieldProviderNpiSection,
  fieldSelectSection,
  fieldTextSection,
  headerSection,
  spacerSection
} from '..';
import { fieldCheckboxSection, fieldSelectStatesSection, fieldTextLabel } from '../field-helpers';
import validatorTypes from '@data-driven-forms/react-form-renderer/dist/cjs/validator-types';

const { prescriberFields } = FIELD_NAMES;
//To fetch size of input box based on user type
const getSize = (values: any) => (values?.user_type === 'Provider' ? { md: 3 } : { md: 6 });

export const getAddUserSchema = (schema: DBFormSchema): Schema => ({
  title: 'add user form',
  fields: [
    // headerSection(schema?.users_information_header?.label, schema?.users_information_header),
    fieldSelectSection('user_type', schema?.user_type, {
      sizes: { md: 6 },
      options: [
        { value: 'Contact', label: 'Contact' },
        { value: 'Provider', label: 'Provider' }
      ]
    }),
    spacerSection(1, { sizes: { sm: 12 } }),
    fieldProviderNpiSection(prescriberFields.npi, schema?.[prescriberFields.npi], {
      sizes: { md: 6 },
      className: 'reset-control-div',
      icon: 'fa-light fa-key',
      condition: {
        when: 'user_type',
        is: 'Provider'
      }
    }),
    {
      component: 'custom-plain-text',
      name: 'npi_info_text',
      label:
        "Begin typing to search for your Prescriber NPI #. If recognized, we'll pre-fill the available information",
      sizes: { md: 6 },
      className: 'npi-info-text',
      condition: {
        when: 'user_type',
        is: 'Provider'
      }
    },
    spacerSection(2, { sizes: { sm: 12 }, className: 'mb-4' }),
    spacerSection(1, { sizes: { sm: 12 } }),
    fieldTextSection(prescriberFields.firstName, schema?.[prescriberFields.firstName], {
      sizes: getSize,
      validate: [
        {
          type: 'name'
        }
      ]
    }),
    fieldTextSection(prescriberFields.middleName, schema?.[prescriberFields.middleName], {
      sizes: { md: 3 },
      validate: [
        {
          type: 'name'
        }
      ],
      condition: {
        when: 'user_type',
        is: 'Provider'
      }
    }),
    fieldTextSection(prescriberFields.lastName, schema?.[prescriberFields.lastName], {
      sizes: getSize,
      validate: [
        {
          type: 'name'
        }
      ]
    }),
    fieldSelectStatesSection(prescriberFields.licensingState, schema?.[prescriberFields.licensingState], {
      sizes: { md: 3 },
      condition: {
        when: 'user_type',
        is: 'Provider'
      }
    }),
    spacerSection(3, { sizes: { sm: 12 }, className: 'mb-4' }),
    fieldTextSection(prescriberFields.email, schema?.[prescriberFields.email], {
      sizes: { md: 6 },
      validate: [
        {
          type: validatorTypes.PATTERN,
          pattern:
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/,
          message: 'Email is invalid'
        }
      ]
    }),
    fieldTextSection('prescriber_confirm_email', schema?.prescriber_confirm_email, {
      sizes: { md: 6 },
      validate: [
        {
          type: 'same-as',
          strict: true,
          compareToField: prescriberFields.email
        },
        {
          type: 'email'
        },
        {
          type: validatorTypes.PATTERN,
          pattern:
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{1,}))$/,
          message: 'Email is invalid'
        }
      ]
    }),
    spacerSection(4, { sizes: { sm: 12 }, className: 'mb-4' }),
    fieldTextSection('username', schema?.username, {
      sizes: { md: 6 },
      validate: [(value: string) => (value.match(/^[\w\S]+$/gi) ? undefined : 'Username cannot contain spaces.')]
    }),
    fieldTextSection(prescriberFields.cellNumber, schema?.[prescriberFields.cellNumber], {
      sizes: { md: 6 },
      type: 'tel',
      Placeholder: '(XXX) XXX-XXXX'
    }),
    fieldTextSection(prescriberFields.fax, schema?.[prescriberFields.fax], {
      sizes: { md: 4 },
      type: 'tel'
    }),
    spacerSection(5, { sizes: { sm: 12 }, className: 'mb-3' }),
    fieldCheckboxSection('is_admin', schema?.is_admin, {
      sizes: { md: 4 },
      options: [
        {
          value: true,
          label: 'Make this user an Administrator'
        }
      ]
    }),
    spacerSection(6, { sizes: { sm: 12 } })
  ]
});

// -----===[test schema]==a=-----
export const addUserSchema: DBFormSchema = {
  users_information_header: { label: "user's information" },
  user_type: { label: 'user type', required: true },
  prescriber_npi: { label: 'prescriber npi', required: true },
  prescriber_first_name: { label: 'first name', required: true },
  prescriber_middle_name: { label: 'middle name' },
  prescriber_last_name: { label: 'last name', required: true },
  prescriber_licensing_state: { label: 'state:' },
  prescriber_email: { label: 'email address', required: true },
  prescriber_confirm_email: { label: 'confirm email address', required: true },
  username: { label: 'username', required: true },
  is_admin: {}
};
